import { Component, Input, inject } from '@angular/core';
import { Stop } from 'modelos/src';
import { HelperService } from '../../../../../../../../auxiliares/servicios/helper.service';

@Component({
  selector: 'app-parada',
  templateUrl: './parada.component.html',
  styleUrl: './parada.component.scss',
  standalone: false,
})
export class ParadaComponent {
  helper = inject(HelperService);

  @Input() parada?: Stop;
}
